import { cn } from '@/lib/utils'
import React from 'react'

interface IIconWrapperProps {
  children: React.ReactElement<React.SVGProps<SVGSVGElement>>
  size?: string | number
  height?: string | number
  color?: string
  className?: string
}

export function IconWrapper({
  children,
  size,
  height,
  color,
  className = ''
}: IIconWrapperProps) {
  return React.cloneElement(children, {
    width: size ?? children.props.width ?? '1em',
    height: height ?? children.props.height ?? '1em',
    fill: color ?? children.props.fill,
    className: cn('inline-block', children.props.className, className)
  })
}
